
/**
 * Constants for image storage functionality
 * Centralized constants to improve maintainability and consistency
 */

// Storage bucket name
export const STORAGE_BUCKET = 'image_uploads';

// Path templates for different image types
export const IMAGE_PATHS = {
  FUND: (id: string) => `fund/${id}`,
  COMPANY: (id: string) => `company/${id}`,
  CONTACT: (id: string) => `contact/${id}`,
  PROFILE: (id: string) => `profile/${id}`
} as const;

// Standard file names
export const FILE_NAMES = {
  PROFILE_AVATAR: 'avatar',
  FUND_LOGO: 'logo',
  COMPANY_LOGO: 'logo',
  CONTACT_AVATAR: 'avatar'
} as const;

// Size limits (in bytes)
export const FILE_SIZE_LIMIT = 5 * 1024 * 1024; // 5MB
export const MINIMUM_SIZE = 1024; // 1KB

// Allowed MIME types
export const ALLOWED_IMAGE_TYPES = [
  'image/jpeg',
  'image/png',
  'image/webp',
  'image/gif'
] as const;

// Cache control settings (in seconds)
export const CACHE_SETTINGS = {
  SHORT: '3600',     // 1 hour
  MEDIUM: '86400',   // 1 day
  LONG: '604800'     // 1 week
} as const;

// Storage API paths with correct format
export const STORAGE_API_PATHS = {
  LIST: '/storage/v1/objects',
  DELETE: '/storage/v1/objects',
  UPLOAD: '/storage/v1/objects',  
  PUBLIC: '/storage/v1/objects/public'
} as const;

// Error codes
export const ERROR_CODES = {
  FILE_TOO_LARGE: 'file_too_large',
  FILE_TOO_SMALL: 'file_too_small',
  INVALID_TYPE: 'invalid_type',
  UPLOAD_FAILED: 'upload_failed',
  DELETE_FAILED: 'delete_failed',
  FETCH_FAILED: 'fetch_failed',
  PROCESSING_FAILED: 'processing_failed'
} as const;
